import React from 'react'
import styles from './styles.module.scss'

interface Props {
    opacity?: boolean
}

export default function LoadingFullscreen(props: Props) {
    return (
        <div style={{ backgroundColor: props.opacity === false ? 'var(--foreground-color)' : 'initial' }} className={styles.container}>
            <div className={styles.loader}></div>
            <div className={styles.overlay} />
        </div>
    )
}
